import { useQuery } from '@tanstack/react-query';

import { DataTable, EmptyState, type Column } from '@axioma/ui';

import { PageHeader } from '../components/PageHeader.js';
import { api } from '../lib/api.js';
import { useAuthStore } from '../stores/auth.js';

interface MatterRow {
  id: string;
  matterNumber: string;
  title: string;
  area: string;
  status: string;
  client: { name: string };
  updatedAt: string;
}

const columns: ReadonlyArray<Column<MatterRow>> = [
  { key: 'number', header: 'Nº', mono: true, render: (r) => r.matterNumber, width: '140px' },
  { key: 'title', header: 'Título', render: (r) => r.title },
  { key: 'client', header: 'Cliente', render: (r) => r.client.name },
  { key: 'area', header: 'Área', render: (r) => r.area },
  { key: 'status', header: 'Status', render: (r) => r.status },
  {
    key: 'updated',
    header: 'Atualizado',
    mono: true,
    render: (r) => new Date(r.updatedAt).toLocaleDateString('pt-BR'),
  },
];

export function Matters(): JSX.Element {
  const tenant = useAuthStore((s) => s.currentTenantId);
  const query = useQuery({
    queryKey: ['matters', tenant],
    queryFn: async () => {
      const { data } = await api.get<{ items: MatterRow[]; total: number }>('/matters', {
        params: { pageSize: 50 },
      });
      return data;
    },
    enabled: Boolean(tenant),
  });

  return (
    <div>
      <PageHeader eyebrow="Estúdio" title="Matters" description="Casos / dossiês ativos no workspace." />
      <div className="px-8 py-6">
        {!query.isLoading && (query.data?.items.length ?? 0) === 0 ? (
          <EmptyState
            title="Nenhum matter aberto"
            description="Crie um matter para agrupar processos, partes, peças e pipelines de IA."
          />
        ) : (
          <DataTable columns={columns} data={query.data?.items ?? []} rowKey={(r) => r.id} loading={query.isLoading} />
        )}
      </div>
    </div>
  );
}
